const Role = Object.freeze({
    Admin: "admin",
    FranchiseManager: "franchiseManager",
    CallCenter: "callCenter",
    StoreManager: "storeManager",
});

export default Role;
